import { render } from "./Home.vue?vue&type=template&id=2c0fc244&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=2c0fc244&lang=scss"
import "./Home.vue?vue&type=style&index=1&id=2c0fc244&lang=scss&scoped=true"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c0fc244"]])

export default __exports__